export const topics = [
  {
    id: "rain-season",
    title: "雨季片单：那些下个不停的雨",
    subtitle: "专题策划 · 6 部作品",
    desc:
      "雨是伦理片里最诚实的道具。它替人物哭，替人物留下，也替人物把不该说的话冲淡。从京都的町屋到首尔的南山，我们挑了六部把雨拍得最好看的作品。",
    tag: "片单",
    keyword: "雨",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20editorial%20image%20for%20a%20rainy%20season%20film%20collection%2C%20rain%20streaming%20down%20a%20dark%20window%20with%20blurred%20warm%20city%20lights%20beyond%2C%20reflections%20on%20wet%20pavement%2C%20deep%20navy%20and%20amber%20palette%2C%20moody%20quiet%20melancholy%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=1200&height=800&seq=ktopic-rain-01&orientation=landscape",
  },
  {
    id: "female-gaze",
    title: "她们的第一人称",
    subtitle: "专题策划 · 女性视角",
    desc:
      "当镜头交到女性导演手里，欲望、婚姻与妥协都有了另一种讲法。这份策划整理了近年最值得一看的女性视角日韩伦理作品。",
    tag: "深度",
    keyword: "女性",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20for%20a%20female%20gaze%20film%20special%2C%20silhouette%20of%20a%20woman%20standing%20in%20a%20dim%20room%20lit%20by%20a%20single%20window%2C%20sheer%20curtain%20moving%20in%20the%20wind%2C%20soft%20dusty%20rose%20and%20charcoal%20palette%2C%20contemplative%20intimate%20mood%2C%20cinematic%20photography%2C%20wide%20composition%2C%20no%20text&width=1200&height=800&seq=ktopic-female-01&orientation=landscape",
  },
  {
    id: "heisei-restore",
    title: "平成余晖：修复版旧作",
    subtitle: "专题策划 · 经典修复",
    desc:
      "胶片的颗粒感是时间留下的指纹。这一辑收录了经过数字修复的平成年代旧作，它们关于家庭、城市与那些说不出口的体面。",
    tag: "修复",
    keyword: "经典",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20for%20a%20restored%20classic%20film%20retrospective%2C%20empty%20old%20Japanese%20cinema%20seats%20lit%20by%20a%20projector%20beam%2C%20dust%20motes%20in%20the%20light%2C%20warm%20sepia%20and%20deep%20umber%20tones%2C%20nostalgic%20quiet%20atmosphere%2C%20wide%20cinematic%20composition%2C%20no%20text&width=1200&height=800&seq=ktopic-heisei-01&orientation=landscape",
  },
  {
    id: "new-2025",
    title: "2025 新片观察",
    subtitle: "专题策划 · 本月上新",
    desc:
      "汉江以西的月租房、奈良古寺里的一场身份追问。2025 年的日韩伦理片，正在把镜头从欲望移回人物本身。",
    tag: "新片",
    keyword: "2025",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20for%20a%20new%20release%20film%20preview%2C%20empty%20city%20street%20at%20night%20after%20rain%20with%20a%20single%20glowing%20cinema%20marquee%20and%20warm%20reflections%2C%20deep%20teal%20and%20soft%20amber%20palette%2C%20modern%20urban%20mood%2C%20cinematic%20wide%20composition%2C%20no%20text&width=1200&height=800&seq=ktopic-new-01&orientation=landscape",
  },
];